// extracted by mini-css-extract-plugin
export var modal = "_49-0";